// extracted by mini-css-extract-plugin
module.exports = {"holder":"YearInput--holder","year":"YearInput--year","epoch":"YearInput--epoch"};